import { gql } from '@apollo/client'

export const PMS_EVENTS_QUERY = gql`
  query PmsEvent($bookingID: String!) {
    PmsEvent(bookingId: $bookingID) {
      bid
      done
      doneAt
      event
      id
      payload
      roomStay
      version
    }
  }
`

export const PMS_EVENT_DONE_MUTATION = gql`
  mutation PmsEventDone($PmsEventDoneInput: PmsEventDoneInput!) {
    PmsEventDone(PmsEventDoneInput: $PmsEventDoneInput) {
      code
      message
    }
  }
`

export const PMS_EVENT_RETRY_LEVEL_MUTATION = gql`
  mutation PmsEventRetryLevel(
    $PmsEventRetryLevelInput: PmsEventRetryLevelInput!
  ) {
    PmsEventRetryLevel(PmsEventRetryLevelInput: $PmsEventRetryLevelInput) {
      code
      message
    }
  }
`
